import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ReloadAppModal({show, handleClose, onConfirm}) {


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{direction:'rtl', textAlign:'right'}}
        size='sm'
        centered
      >
        <Modal.Header className='bg-warning' style={{height:'70px'}}>
            <i className='fa fa-exclamation-circle text-secondary fs-1  mx-auto'></i>
        </Modal.Header>
        <Modal.Body className='text-center'>
            <div style={{fontSize:'1rem', minHeight:"50px"}} className='d-flex justify-content-center align-items-center'>
                مدتی است که با برنامه کار نکرده اید
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" className='mx-auto' onClick={onConfirm}>به روز رسانی صفحه</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReloadAppModal;